import {ContainerConfigInterface} from "../interface";

export interface PaiPointButtonInterface {
    containerId: string
    containerConfig: ContainerConfigInterface
    itemConfig: PaiPointButtonPropsInterface
}

export interface PaiPointButtonPropsInterface extends ContainerConfigInterface {
    label: string
    loading?: boolean
    type?: "text" | "link" | "primary" | "default" | "dashed" | undefined,
    action?: PaiPointButtonActionInterface
}

export interface PaiPointButtonActionInterface {
    type: PaiPointButtonType,
    url: string
}

export type PaiPointButtonType =
    PaiPointButtonActionTypeEnum.LINK |
    PaiPointButtonActionTypeEnum.NAVIGATE |
    PaiPointButtonActionTypeEnum.FUNCTION

export enum PaiPointButtonActionTypeEnum  {
    LINK = 'link',
    NAVIGATE = 'navigate',
    FUNCTION = 'function'
}